import { Pipe, PipeTransform } from '@angular/core';
import { TrackingData } from '../providers/tracking';
import { Observable } from 'rxjs/Observable';
import { UtilitiesProvider } from '../providers/utilities';

@Pipe({
  name: 'getCommercialMatch'
})

export class CommercialMatchPipe implements PipeTransform {

  constructor(
    private tracking: TrackingData,
    private utilities: UtilitiesProvider
  ) {}

  transform(commercial: any, clientId: string, eventId: string, userId: string): any {
    if (commercial.ai) {
      return Observable.of(commercial);
    } else {
      return this.tracking.findEntityById(clientId, userId, commercial.id, this.utilities.validateEventIdParam(eventId) ? 'event_commercial_sample' : 'commercial_sample')
        .map(result => result.data);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/commercial-ai.pipe.ts